import React, { Component } from 'react';
import { inject } from 'mobx-react';
import { Card, Spinner } from 'reactstrap';
import GoogleMapReact from 'google-map-react';
import { MapMarker} from './MapMarker';

@inject("mobxStore")
export class GoogleMap extends Component {

    mapClick = (key, childProps) => {
        this.props.history.push(`/property/${childProps.listing.listingId}`);
    }

    mapEnter = (key, childProps) => {
        this.props.mobxStore.setMapMarkerId(childProps.listing.listingId);
    }

    mapLeave = (key, childProps) => {
        this.props.mobxStore.setMapMarkerId('');
    }

    render () {
        const {properties} = this.props;

        return (
            <Card body style={{ height: '100vh', width: '100%' }}>
            { properties && properties.length > 0 &&
                <GoogleMapReact
                    bootstrapURLKeys={{ key: 'AIzaSyDBNtUsVcEyN-v6hyXa0-cvZHj4lzjmLgE' }}
                    defaultCenter={{lat: 26.87509092, lng: -82.32016863}}
                    defaultZoom={14.5}
                    onChildClick={this.mapClick}
                    onChildMouseEnter={this.mapEnter}
                    onChildMouseLeave={this.mapLeave}
                    >

                    { properties.filter(r => r.lat > 0).map((l, index) =>
                        (
                            <MapMarker key={index}
                                lat={l.lat}
                                lng={l.lng}
                                listing={l}/>
                        ))
                    }
                </GoogleMapReact>
            }
            { !properties &&
                <Spinner size="lg"/>
            }
            </Card>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/GoogleMap.jsx